<template>
  <div id="centerTop">
    <Map></Map>
  </div>
</template>

<script>
  import Map from './components/map'
  export default {
    components: {
      Map
    }
  }
</script>

<style lang="scss" scoped>
#centerTop {
  $box-height: 640px;
  $box-width: 800px;
  padding: 5px;
  margin-left: -50px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    padding: 5px;
    height: $box-height;
    width: $box-width;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/screen/CenterTop.vue